import ErrorIndicator from "./error";

export default ErrorIndicator;
